import { useReportBlockNodeBuilder } from '@va/dashboard/shared/report-block-nodes';
import { useTranslate } from '@va/localization';
import { DataViewOption } from '@va/types/report-block';
import { DataTableV8, useControlledTableState } from '@va/ui/components/data-table';
import { ReportBlock, ReportBlockNodeIds, useReportBlockCtx } from '@va/ui/components/report-block';
import { useMemo } from 'react';
import { useGetWebsiteInvoices, WebsiteInvoicesTypes } from './invoices-api-client';
import { useWebsiteInvoicesColumns } from './useWebsiteInvoicesColumns';

const WEBSITE_INVOICES_RB = 'website-invoices';

const WebsiteInvoices = () => {
  const translate = useTranslate();
  const buildReportBlockNode = useReportBlockNodeBuilder();

  const visualizationComponents = useMemo(() => {
    return {
      [DataViewOption.table]: Table,
    };
  }, []);

  return (
    <ReportBlock
      id={WEBSITE_INVOICES_RB}
      nodes={{
        columnVisibility: buildReportBlockNode(ReportBlockNodeIds.COLUMN_VISIBILITY),
      }}
      title={translate('standalone.accountSettings.invoices.websiteInvoices.table.title')}
      titleTooltip={translate('standalone.accountSettings.invoices.websiteInvoices.table.titleTooltip')}
      visualization={{ selectedView: DataViewOption.table }}
      visualizationComponents={visualizationComponents}
    ></ReportBlock>
  );
};

export default WebsiteInvoices;

const Table = () => {
  const columns = useWebsiteInvoicesColumns();
  const { id, paginationId } = useReportBlockCtx();
  const { isLoading, data } = useGetWebsiteInvoices();
  const { pagination, setPagination, grouping, setGrouping, sorting, setSorting, defaultSorting } =
    useControlledTableState<WebsiteInvoicesTypes>(
      {
        pagination: { pageSize: 6 },
        defaultSorting: [{ id: 'date', desc: true }],
      },
      id,
    );

  return (
    <DataTableV8
      id='website-invoices-table'
      columns={columns}
      data={data ?? []}
      isLoading={isLoading}
      state={{
        pagination,
        grouping,
        sorting,
      }}
      paginationContainerId={paginationId}
      onPaginationChange={setPagination}
      onGroupingChange={setGrouping}
      onSortingChange={setSorting}
      manualSorting={false}
      manualPagination={false}
      className='max-h-500px'
      getRowId={(row) => row.receiptUrl}
      defaultSorting={defaultSorting}
    />
  );
};
